import constants from '@components/SiteNav/constants';

const state = {
  selectedSiteDesktopNav: 0,
  siteNavMobileNavOpen: false,
  breadcrumbs: [],
  currentMobileNav: 'TOP_NAV',
  mobileNavSlideAnimation: "fade-slide-left",
  mobileTopMenuFocusRef: null
};

const getters = {
  currentMobileNavData(state) {
    return constants[state.currentMobileNav];
  }
};

const actions = {
  toggleMobileSiteNav({ state, commit }) {
    commit('setSiteNavMobileNavOpen', !state.siteNavMobileNavOpen);

    if (state.siteNavMobileNavOpen) {
      if (state.mobileTopMenuFocusRef) {
        state.mobileTopMenuFocusRef.focus();
      }
      commit('setCurrentMobileNav', 'TOP_NAV');
    }
  },

  navigateTo({ state, commit, dispatch }, params) {
    commit('setMobileNavSlideAnimation', 'fade-slide-left');
    const { subNav } = params;
    dispatch('addBreadcrumb', state.currentMobileNav);
    commit('setCurrentMobileNav', subNav);
  },

  goBack({ state, commit, dispatch }) {
    commit('setMobileNavSlideAnimation', 'fade-slide-right');
    let previousNav = state.breadcrumbs[state.breadcrumbs.length - 1];
    commit('setCurrentMobileNav', previousNav);
    dispatch('removeBreadcrumb');
  },

  addBreadcrumb({ state, commit }, crumb) {
    if (crumb) {
      let newCrumbs = [...state.breadcrumbs];
      newCrumbs.push(crumb);
      commit('setBreadcrumbs', newCrumbs);
    }
  },

  removeBreadcrumb({ state, commit }) {
    let newCrumbs = state.breadcrumbs.slice(0, -1);
    commit('setBreadcrumbs', newCrumbs);
  },
};

const mutations = {
  setSelectedSiteDesktopNav(state, val) {
    if (state.selectedSiteDesktopNav == val) {
      val = 0;
    }

    state.selectedSiteDesktopNav = +val;
  },

  setSiteNavMobileNavOpen(state, val) {
    state.siteNavMobileNavOpen = val;
  },

  setCurrentMobileNav(state, val) {
    state.currentMobileNav = val;
  },

  setBreadcrumbs(state, val = []) {
    state.breadcrumbs = val;
  },
  setMobileNavSlideAnimation(state, val) {
    state.mobileNavSlideAnimation = val || "fade-slide-left";
  },

  setMobileTopMenuFocusRef(state, val) {
    state.mobileTopMenuFocusRef = val;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
